import React from 'react';

const UNIT = { compiling: 'rules', scoring: 'POs' };

// "87 / 161 rules" (or "6 / 14 POs · batch 2 of 3") with a thin bar, under a rule set's status.
function RuleProgressBar({ progress }) {
    if (!progress || !progress.total) return null;
    const percent = Math.round((100 * progress.done) / progress.total);
    const detail = progress.detail ? ` · ${progress.detail}` : '';
    return (
        <div className="rule-progress" title={`${percent}%`}>
            <div className="rule-progress-text">
                {progress.done} / {progress.total} {UNIT[progress.stage]}{detail}
            </div>
            <div className="rule-progress-track">
                <div className="rule-progress-fill" style={{ width: `${percent}%` }} />
            </div>
        </div>
    );
}

export default RuleProgressBar;
